<template>
  <div class="row">
    <div class="col-lg col-6 bg-black p-4">
      <div class="row text-white">
        <div class="col-5 d-none d-md-block">
          <font-awesome-icon icon="users" size="5x"></font-awesome-icon>
        </div>
        <div class="col-12 col-md-7 text-center">
          <h4 class="d-block" v-if="roles.loaded">{{ roles[6].count || 0 }}</h4>
          <h4 class="d-block" v-else><font-awesome-icon icon="cog" spin></font-awesome-icon></h4>
          <span>APPRENTICE</span>
        </div>
      </div>
    </div>
    <div class="col-lg col-6 bg-lime p-4">
      <div class="row text-white">
        <div class="col-5 d-none d-md-block">
          <font-awesome-icon icon="users" size="5x"></font-awesome-icon>
        </div>
        <div class="col-12 col-md-7 text-center">
          <h4 class="d-block" v-if="roles.loaded">{{ roles[7].count || 0 }}</h4>
          <h4 class="d-block" v-else><font-awesome-icon icon="cog" spin></font-awesome-icon></h4>
          <span>GREEN</span>
        </div>
      </div>
    </div>
    <div class="col-lg col-6 bg-grey p-4">
      <div class="row text-white">
        <div class="col-5 d-none d-md-block">
          <font-awesome-icon icon="users" size="5x"></font-awesome-icon>
        </div>
        <div class="col-12 col-md-7 text-center">
          <h4 class="d-block" v-if="roles.loaded">{{ roles[8].count || 0 }}</h4>
          <h4 class="d-block" v-else><font-awesome-icon icon="cog" spin></font-awesome-icon></h4>
          <span>SILVER</span>
        </div>
      </div>
    </div>
    <div class="col-lg col-6 bg-gold p-4">
      <div class="row text-white">
        <div class="col-5 d-none d-md-block">
          <font-awesome-icon icon="users" size="5x"></font-awesome-icon>
        </div>
        <div class="col-12 col-md-7 text-center">
          <h4 class="d-block" v-if="roles.loaded">{{ roles[9].count || 0 }}</h4>
          <h4 class="d-block" v-else><font-awesome-icon icon="cog" spin></font-awesome-icon></h4>
          <span>GOLD</span>
        </div>
      </div>
    </div>
    <div class="col-lg col-6 bg-platinum p-4">
      <div class="row text-white">
        <div class="col-5 d-none d-md-block">
          <font-awesome-icon icon="users" size="5x"></font-awesome-icon>
        </div>
        <div class="col-12 col-md-7 text-center">
          <h4 class="d-block" v-if="roles.loaded">{{ roles[10].count || 0 }}</h4>
          <h4 class="d-block" v-else><font-awesome-icon icon="cog" spin></font-awesome-icon></h4>
          <span>PLATINUM</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UsersCount',
  data () {
    return {
      roles: {
        loaded: false
      }
    };
  },
  mounted () {
    this.axios.get('/statistics/roles').then(rsp => {
      rsp.data.loaded = true;
      this.roles = rsp.data;
    });
  }
};
</script>
